import { get, get1, post, puts, postimg, download } from './http'

export const Login = p => post('?q=app/user/login', p)

export const getToken = p => post('?q=app/user/token', p)

// 获取验证码
export const captchaSms = p => post('api/v2/captcha/sms', p)

// 上传图片
export const uploadimage = p => postimg('api/v2/upload/image', p)

// 获取临时身份
export const uploadassumeRole = p => get('api/v2/upload/assumeRole', p)

// 登录
export const loginpassword = p => post('api/v2/login/password', p); 0

// 注册
export const registersms = p => post('api/v2/register/sms', p)

// 修改密码
export const detailpassword = p => post('api/v2/member/detail/password', p)

// 用户信息
export const memberdetail = p => get('api/v2/member/detail', p)

// 轮播图
export const bannerlist = p => get('api/v2/banner/list')

// 系列图库展示列表
export const seriesgallerylist = p => get('api/v2/series_gallery/list')

// 设计指南列表
export const seriesgallerys = p => get1('api/v2/series_gallery', p)

// 设计指南详情
export const seriesgallery = p => get1('api/v2/series_gallery/' + p.id)

// 系列图库列表
export const newseriesgallerys = p => get1('api/v2/new_series_gallery', p)

// 系列图库详情
export const newseriesgallery = p => get1('api/v2/new_series_gallery/' + p.id)

// 首页展示列
export const designerdemandlist = p => get('api/v2/designer_demand/list', p)

// 设计之星列表
export const designerstarlist = p => get('api/v2/designer_star/list')

// 经典案例列表
export const classiccaselist = p => get('api/v2/classic_case', p)

// 经典案例列表
export const classiccase = p => get('api/v2/classic_case/' + p.id)

// 材料列表
export const materialparents = p => get1('api/v2/material_gallery/materialparents')

// 材料列表
export const materials = p => get1('api/v2/material_gallery/materials/' + p.id)

// 材料图列表
export const materialgallery = p => get('api/v2/material_gallery', p)

// CAD图库列表
export const cadgallerys = p => get('api/v2/cad_gallery', p)

// CAD图库详情
export const cadgallery = p => get('api/v2/cad_gallery/' + p.id)

// 获取assumeRole身份
export const assumeRole = p => get('api/v2/upload/assumeRole')

// 投标
export const designerdemanddoBid = p => puts('api/v2/designer_demand/doBid', p)

// 下载需求方案
export const designerdownload = p => get('api/v2/designer_demand/' + p.id + '/doDownload')

// 上传附件
export const designerdoUpload = p => puts('api/v2/designer_demand/doUpload', p)

// 电子相册编辑页数据
export const editAlbum = p => get('api/v2/designer_demand/' + p.id + '/editAlbum')

// 保存电子相册
export const storeAlbum = p => puts('api/v2/designer_demand/storeAlbum', p)

// 保存电子相册
export const designerdemand = p => get('api/v2/designer_demand/' + p.id)

// 获取上传的附件信息
export const beforeUpload = p => get('api/v2/designer_demand/' + p.id + '/beforeUpload')

// 获取技术手册列表
export const manuallist = p => get('api/v2/manual', p)

// 获取技术手册详细
export const manualdata = p => get('api/v2/manual/' + p.id)

// 获取各页面图片
export const layoutlist = p => get('api/v2/layout/list', p)

// 获取各视频素材列表
export const vadiolist = p => get('api/v2/video', p)

// 获取素材视频链接
export const sucaivadio = p => get('api/v2/video/' + p.id)

// 获取小概念pdf列表
export const test_reports = p => get('api/v2/test_report', p)

// 获取小概念pdf详情
export const test_report = p => get('api/v2/test_report/' + p.id)

// 常见设计问题
export const designProblems = p => get('api/v2/design_problem', p)

// 参考图库列表
export const reference_gallerys = p => get('api/v2/reference_gallery', p)

// 参考图库详情
export const reference_gallery = p => get('api/v2/reference_gallery/' + p.id)

// 只是产权分类
export const intellectualPropertyTypes = p => get('api/v2/test_report/intellectualPropertyTypes')

// 点赞经典案例
export const classic_case_like = p => puts('api/v2/classic_case/' + p.id + '/like')

// 分享经典案例
export const classic_case_share = p => get('api/v2/classic_case/' + p.id + '/share')

// 经典案例全部评论
export const classic_case_replies = p => get('api/v2/classic_case/' + p.id + '/replies')

// 评论经典案例
export const classic_case_reply = p => post('api/v2/classic_case/' + p.id + '/reply', p)

// 点赞经典案例评论
export const classic_case_reply_like = p => puts('api/v2/classic_case/reply/' + p.id + '/like')

// 设计历练首页
export const jibieExam = p => get('api/v2/exam')

// 开始考试
export const examStart = p => get('api/v2/exam/start', p)

// 提交考试
export const examSubmit = p => post('api/v2/exam/submit', p)

// 考试排行榜
export const examRank = p => get('api/v2/exam/rank', p)

// 考试奖励榜
export const examRewards = p => get('api/v2/exam/rewards')

// 考试数据分析
export const examStatistics = p => get('api/v2/exam/statistics', p)

// 参与考试人员数据
export const examDesigners = p => get('api/v2/exam/designers')

// 头像列表
export const getDetailAvatar = p => get1('api/v2/member/detail/avatar')

// 修改头像
export const postDetailAvatar = p => post('api/v2/member/detail/avatar', p)

// 修改头像
export const getmydemands = p => get('api/v2/designer_demand/mylist', p)

// 获取审核信息
export const getAudit = p => get('api/v2/designer_demand/demandProgrammeRecords/' + p.id)

// 审核订单
export const doAudit = p => get('api/v2/designer_demand/doAudit', p)

// 取消审核订单
export const cancelAudit = p => get('api/v2/designer_demand/cancelAudit', p)
// export const doAudit = p => get('api/v2/designer_demand/'+p.id+'/'+p.demanid+'/doAudit');

// 下载需求方案
export const mydesignerListExport = p => download('api/fittings/parts/partlistExport', p)

// 收费等级统计
export const getQrCode = p => download('api/v2/designer_demand/' + p.id + '/scoreQrCode')

// 设计服务模块：获取顶部轮播图
export const getCarouselImgList = p => get('api/v2/design_serve/banner/list', p)

// 设计服务模块：获取设计服务数据
export const getDesignServiceList = p => get('api/v2/design_serve/crm_project/' + p)

// 设计服务模块：新增设计服务数据
export const saveDesignServiceList = p => post('api/v2/design_serve/crm_project', p)

// 设计服务模块：取消设计服务
export const cancelDesignService = p => post('api/v2/design_serve/crm_project/cancel/' + p)

// 设计服务模块：修改设计服务数据
export const updateDesignServiceList = p => post('api/v2/design_serve/alter_crm_project', p)

// 设计服务模块：获取设计师数据
export const getDesignerList = p => get('api/v2/design_serve/designer/list', p)

// 设计服务模块：获取下拉框选项数据
export const getSelectOptionList = p => get('api/v2/design_serve/crm_project/create', p)

// 设计服务模块：提交评价
export const saveRateData = p => post('api/v2/design_serve/evaluation/' + p.crm_id, p.data)

// 设计服务模块：允许修改申请设计数据
export const allowModifyApplyDesignData = p => post('api/v2/design_serve/crm_project/allow_alter/' + p)

// 设计服务模块：获取相关权限
export const getApplyDesignPermission = p => get('api/v2/design_serve/permissions', p)

// 设计服务模块：允许修改设计服务确认函数据
export const allowModifyConfirmationLetter = p => post('api/v2/design_serve/service_confirm/allow_alter/' + p)

// 设计服务模块：获取确认函内下拉框选项
export const getConLetSelectOptionList = p => get('api/v2/design_serve/service_confirm/create', p)

// 设计服务模块：获取确认函表格数据
export const getConfirmationLetterList = p => get('api/v2/design_serve/service_confirm/' + p)

// 设计服务模块：保存确认函表格数据
export const saveConfirmationLetterList = p => post('api/v2/design_serve/service_confirm/' + p.crm_id, p.data)

// 记录页面浏览量数据
export const recordPageViews = p => post('api/v2/visit_record/store', p)

// 获取页面浏览量数据
export const getPageViews = p => get('api/v2/statistics_visit_record/index', p)

// 获取微信公众号访问量数据
export const getWinXinPageVies = p => get('api/v2/statistics_visit_record/gzh_index', p)

// 获取设计师详情
export const getDesignerInfo = p => get('api/v2/design_serve/designer/' + p.designerId)

// 获取设计服务订单类型
export const getDesignOrderList = p => get('api/v2/design_serve/events_list')

// 获取设计服务下单率
export const getDesignXiadanlv = p => get('api/v2/design_serve/xiadanlv/' + p.crm_id)

// 获取精品案例列表
export const finedesignlist = p => get('api/v2/fine_design', p)

// 获取精品案例详细
export const finedesign = p => get('api/v2/fine_design/' + p.id)



// WEBPACK FOOTER //
// ./src/request/api.js